import { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import renderImage from '../../../source/importImg'
import style from '../../ReusableComponents/DialogModal/DialogModal.module.css'
import loaderStyle from './ViewActions.module.css'
import { readBytes, sendBytes } from '../../ReusableComponents/ByteTransfer'
import { actionsToBytes } from './ActionsCreate'
import { saveAs } from 'file-saver'
import ActionLoader from './ActionLoader'

import {
    calculateWaitTime,
    getMountPoint,
    writeFile,
} from '../../../utils/readWriteFile'
import { CREATEACTIONSTATE } from './defaultData'
import { decimalToMSBLSB } from '../../ReusableComponents/ByteTransfer/utils'

let status = true
const INITIAL_FEEDBACK = {
    isOn: false,
    msg: '',
}
const SavePopUp = (props) => {
    let actionsData
    try {
        actionsData = JSON.parse(sessionStorage.getItem('createActionState'))
    } catch (e) {
        actionsData = JSON.parse(JSON.stringify(CREATEACTIONSTATE))
    }
    const [fileName, setFileName] = useState('')
    const [feedback, setFeedback] = useState(INITIAL_FEEDBACK)
    const [showActionLoader, setShowActionLoader] = useState(false)
    const [loader, setLoader] = useState(true)
    let connectedDevice = sessionStorage.getItem('connectedDevice')
    let deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'

    const waitTimeRef = useRef(null)
    const useRefExtensionsReadRef = useRef({
        commendSend: false,
        commend: '',
        response: '',
    })

    const timeoutPromise1 = (ms) => {
        return new Promise((resolve, reject) => {
            waitTimeRef.current = setTimeout(() => {
                reject(new Error('Timeout exceeded'))
            }, ms)
        })
    }
    // const timeoutPromise1 = (ms) => {
    //     return new Promise((resolve, reject) => {
    //         setTimeout(() => {
    //             console.log('HHHHHHHHHH Time Out')
    //             sendDataAsPacket.current = {
    //                 byteSend: false,
    //                 responseMessage: '',
    //             }
    //             reject(new Error('Timeout exceeded'))
    //         }, ms)
    //     })
    // }

    const checkOk = async () => {
        return new Promise(async (resolve, reject) => {
            while (true) {
                // console.log(
                //     'DDDDDDDD',
                //     useRefExtensionsReadRef.current.commendSend
                // )
                if (!useRefExtensionsReadRef.current.commendSend) {
                    if (waitTimeRef.current) {
                        clearTimeout(waitTimeRef.current)
                        waitTimeRef.current = null
                    }
                    return resolve()
                }

                await new Promise((reslove) => {
                    setTimeout(reslove, 100)
                })
            }
        })
    }

    useEffect(() => {
        if (props.showPopUp === false) {
            setFileName('')
        }
    }, [props.showPopUp])

    let inputHandler = (event) => {
        if (props.isNotCreateAction) {
            setFileName(`${event.target.value}`)
        } else setFileName(`${event.target.value}`.toUpperCase())
    }

    //check the user input file name is validation
    const isValidFName = (fName) => {
        const validNamePattern = /^[a-zA-Z_$][a-zA-Z0-9_$]*$/
        return validNamePattern.test(fName)
    }

    const saveFile = async () => {
        if (props.isNotCreateAction) {
            sessionStorage.setItem('isSave', JSON.stringify(true))

            const fileData = JSON.stringify(sessionStorage)
            const blob = new Blob([fileData], { type: 'text/plain' })
            if (fileName.length !== 0) {
                saveAs(blob, `${fileName}.pld`)
                props.setFilePopUp(false)
            }
        } else if (!props.isShowNewUI) {
            sessionStorage.setItem('isSave', JSON.stringify(true))
            if (!isValidFName(fileName)) {
                showSaveFeedBack('This is not a valid file name.', false)
                return
            }
            //in the board the file name name accept less than or equal to 10
            if (fileName.length > 10) {
                showSaveFeedBack(
                    'File name content maximum 10 character.',
                    false
                )
                return
            }

            props.setFilePopUp(false)
            const fileData = JSON.stringify(sessionStorage)
            const blob = new Blob([fileData], { type: 'text/plain' })
            if (fileName.length !== 0) saveAs(blob, `${fileName}.pld`)
        } else {
            //projectName
            sessionStorage.setItem('isSave', JSON.stringify(true))
            props.setFilePopUp(false)
            let fileData = JSON.parse(JSON.stringify(sessionStorage))
            fileData.createActionMusic = props.audioFile
            fileData = JSON.stringify(fileData)
            const blob = new Blob([fileData], { type: 'text/plain' })

            if (props?.projectName?.length !== 0)
                saveAs(blob, `${props.projectName}.pld`)

            // if (props?.audioFile && props?.projectName?.length !== 0) {
            //     const zip = new JSZip()
            //     const mp3Response = await fetch(props.audioFile)
            //     console.log('HHHHHHHHH', props.audioFile)
            //     const mp3Blob = await mp3Response.blob() // Convert URL to Blob
            //     zip.file(`${props.projectName}.mp3`, mp3Blob)
            //     zip.file(`${props.projectName}.pld`, blob)

            //     // Generate ZIP file and trigger download
            //     zip.generateAsync({ type: 'blob' }).then((zipBlob) => {
            //         saveAs(zipBlob, `${props.projectName}.zip`)
            //     })
            // } else {
            //     if (props?.projectName?.length !== 0)
            //         saveAs(blob, `${props.projectName}.pld`)
            // }
        }
    }

    //get mount point of the sd card
    const getSdCardMountPoint = async () => {
        let sdCardMountAt = await getMountPoint({
            socket: props.socketData.socket,
        })
        props.deviceMismatch({
            ...props.device,
            plodeNativeData: {
                ...props.device.plodeNativeData,
                mountPoint: sdCardMountAt,
            },
        })

        return sdCardMountAt
    }

    //hex program save to board
    const hexProgramSaveToBoard = async () => {
        if (fileName.length === 0) {
            return
        }
        try {
            // setShowActionLoader(true)
            let programBytes = await props.programsaveToBoard()
            const MSBLSBRowLength = decimalToMSBLSB(programBytes.length)
            programBytes.unshift(...MSBLSBRowLength)

            const actionsUint8Array = new Uint8Array(programBytes)
            let base64FileData = btoa(String.fromCharCode(...actionsUint8Array))
            let sdCardMountAt = props.device.plodeNativeData.mountPoint
            if (!sdCardMountAt) {
                sdCardMountAt = await getSdCardMountPoint()
            }

            let device = 'zing'
            if (connectedDevice === 'Hexapod') device = 'crawle'
            if (connectedDevice === 'Klaw') device = 'klaw'
            let filePath = `${sdCardMountAt}/${device}/programs`

            let fileSaveResponse = await writeFile({
                socket: props.socketData.socket,
                fileName: fileName,
                fileFormat: 'bin',
                filePath: filePath,
                fileData: base64FileData,
                writeTime: 30000,
            })

            if (fileSaveResponse.success) {
                setShowActionLoader(false)
                showSaveFeedBack('Program saved successfully', true)
            } else {
                setShowActionLoader(false)
                showSaveFeedBack('Program does not save', false)
            }
        } catch (e) {
            setShowActionLoader(false)
            showSaveFeedBack('Program does not save', false)
        }
    }

    //use the extensions and nativ application to save the mp3 file and action in the board
    const extensionsFileSave = async (actionBytes, actionDetailsObj) => {
        try {
            let sdCardMountAt = props.device.plodeNativeData.mountPoint
            if (!sdCardMountAt) {
                sdCardMountAt = await getSdCardMountPoint()
            }
            // sessionStorage.getItem('sdCardMountAt') || 'NO NAME'
            let device = 'ZING'
            if (connectedDevice === 'Hexapod') device = 'hexapod'
            let filePath = `${sdCardMountAt}/${device}/actions/user`

            if (props.audioFile) {
                const base64Data = props.audioFile.split(',')[1] // Data URL (Base64 encoded) than  Remove "data:*/*;base64," prefix
                // const byteArray = atob(base64Data)
                //     .split('')
                //     .map((c) => c.charCodeAt(0))
                // const uint8Array = new Uint8Array(byteArray)
                // const mp3FileSize = uint8Array.length
                // let fileData = uint8Array.join(',')
                // let mp3WaitTime = calculateWaitTime(mp3FileSize)

                //save  the mp3 file in board
                let mp3SaveResponse = await writeFile({
                    socket: props.socketData.socket,
                    fileName: props.projectName,
                    fileFormat: 'mp3',
                    filePath: filePath,
                    fileData: base64Data,
                    writeTime: 120000,
                })

                if (mp3SaveResponse.success) {
                } else {
                    setShowActionLoader(false)
                    showSaveFeedBack('Action does not save', false)
                    return
                }

                // let mp3Datas = `add --name "${fileName}" --format "${'mp3'}" --data """${fileData}"""`
                // let mp3Datas = `add --name "${
                //     props.projectName
                // }" --format "${'mp3'}" --path "/Volumes/${sdCardMountAt}/${device}/actions/user"  --data """${fileData}"""`
                // // Send message to content script audioFile
                // window.postMessage({ type: 'sendMessage', data: mp3Datas }, '*')

                // useRefExtensionsReadRef.current = {
                //     commendSend: true,
                //     commend: 'saveFile',
                //     response: '',
                // }
                // let replyOK = await Promise.race([
                //     checkOk(),
                //     timeoutPromise1(mp3WaitTime),
                // ])
            }
            const actionsUint8Array = new Uint8Array(actionBytes)

            // Convert object to UTF-8 bytes
            const actionsDetailsUint8Array = new TextEncoder().encode(
                JSON.stringify(actionDetailsObj)
            )

            let actionWaitTime = calculateWaitTime(actionsUint8Array.length)

            // let actionFileData = actionsUint8Array.join(',')
            // const actionsDetailsData = Array.from(
            //     actionsDetailsUint8Array
            // ).join(',')

            // Encode to base64 string
            let actionsBase64Data = btoa(
                String.fromCharCode(...actionsUint8Array) +
                    String.fromCharCode(...actionsDetailsUint8Array)
            )

            //save  the bin file in board
            let binSaveResponse = await writeFile({
                socket: props.socketData.socket,
                fileName: props.projectName,
                fileFormat: 'bin',
                filePath: filePath, //'/Volumes/NO NAME/ZING/actions/user'
                fileData: actionsBase64Data,
                writeTime: actionWaitTime,
            })
            if (binSaveResponse.success) {
                setShowActionLoader(false)
                showSaveFeedBack('Action saved successfully', true)
            } else {
                setShowActionLoader(false)
                showSaveFeedBack('Action does not save', false)
            }
            // let actionDatas = `add --name "${fileName}" --format "${'bin'}" --data """${
            //     actionFileData + ',' + actionsDetailsData
            // }"""` //"/Volumes/NO NAME/hexapod/actions/user"

            // let actionDatas = `add --name "${
            //     props.projectName
            // }" --format "${'bin'}" --path "/Volumes/${sdCardMountAt}/${device}/actions/user" --data """${
            //     actionFileData + ',' + actionsDetailsData
            // }"""`
            // Send message to content script action file
            // window.postMessage({ type: 'sendMessage', data: actionDatas }, '*')

            // useRefExtensionsReadRef.current = {
            //     commendSend: true,
            //     commend: 'saveFile',
            //     response: '',
            // }
            // let replyOK1 = await Promise.race([
            //     checkOk(),
            //     timeoutPromise1(actionWaitTime),
            // ])
            // setShowActionLoader(false)
            // showSaveFeedBack('Action saved successfully', true)
        } catch (e) {
            // useRefExtensionsReadRef.current = {
            //     commendSend: false,
            //     commend: '',
            //     response: '',
            // }
            setShowActionLoader(false)
            showSaveFeedBack('Action does not save', false)
            console.error(e)
        }
    }

    //save to board
    const uploadToBoard = async () => {
        if (!props.webSerial.isConnected) {
            showSaveFeedBack('Please connect the device.', false)
            return
        }
        if (props.isNotCreateAction) {
            hexProgramSaveToBoard()
            return
        }

        const actionsData = JSON.parse(
            sessionStorage.getItem('createActionState')
        )
        if (props.isShowNewUI) {
            setShowActionLoader(true)
            const { data, waitTime, status, actionDetailsObj } = actionsToBytes(
                {
                    actionsData,
                    AGSlotId: 1,
                    mode: 'ALLACTIONS',
                    SingleAction: '',
                    fileName: props.projectName,
                    isShowNewUI: props.isShowNewUI,
                }
            )
            if (!status) {
                showSaveFeedBack(
                    `Invalid marker position! Each action's completion time must be between 100ms and 5000ms.`,
                    false
                )
                setShowActionLoader(false)
                return
            }
            await extensionsFileSave(data, actionDetailsObj)
            return
        }

        if (!isValidFName(fileName)) {
            showSaveFeedBack('This is not a valid file name.', false)
            return
        }
        //in the board the file name name accept less than or equal to 8
        if (fileName.length > 10) {
            showSaveFeedBack('File name content maximum 8 character.', false)
            return
        }
        setShowActionLoader(true)

        let file = ['{'.charCodeAt(0)]
        file = file.concat(
            `${fileName + '.BIN'}`
                .split('')
                .map((val) => val.charCodeAt(0))
                .concat(['}'.charCodeAt(0)])
        )
        let replyOK

        if (['1', '2', '3'].includes(deviceVersion[0])) {
            //for zing v2 board create save action bytes and sen to the board
            const { data, waitTime } = actionsToBytes({
                actionsData,
                AGSlotId: 1,
                mode: 'ALLACTIONS',
                SingleAction: '',
                fileName,
                isShowNewUI: props.isShowNewUI,
            })
            props.worker.postMessage({
                type: 'writeArray',
                value: data,
            })
            sessionStorage.setItem('sendDataAsPacket', 'true')
            try {
                let replyOK = await Promise.race([
                    checkSave(),
                    timeoutPromise(5000),
                ])
                setShowActionLoader(false)
                showSaveFeedBack('Action saved successfully', true)
            } catch (e) {
                setShowActionLoader(false)
                showSaveFeedBack('Action does not save', false)
            }
        } else {
            await sendBytes(file, props.webSerial.port)
            replyOK = await readBytes(props.webSerial.port, 'OK')
            console.log(replyOK)
            if (replyOK) {
                const { data, waitTime } = actionsToBytes({
                    actionsData,
                    AGSlotId: 1,
                    mode: 'ALLACTIONS',
                    SingleAction: '',
                    fileName: '',
                    isShowNewUI: false,
                })

                // if (
                //     ['1', '2'].includes(
                //         (sessionStorage.getItem('deviceVersion') || '0.0.0')[0]
                //     ) &&
                //     ['Humanoid'].includes(
                //         sessionStorage.getItem('connectedDevice')
                //     )
                // ) {
                //     sendDataAsPackets_zingV2(data, 43, props.webSerial.port)
                // } else {
                sendSaveDataAsPackets(data, 43, props.webSerial.port)
                // }
            }
        }
    }

    //after the Save came from zing show a feedBack message and remove the save popup
    const showSaveFeedBack = (msg, isClose) => {
        setFeedback({
            isOn: true,
            msg,
        })
        setTimeout(() => {
            setFeedback({
                isOn: false,
                msg: null,
            })
            if (isClose) {
                props.setFilePopUp(false)
            }
        }, 2000)
    }

    // and also sends them at the given interval
    const timeoutPromise = (ms) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                reject(new Error('Timeout exceeded'))
            }, ms)
        })
    }

    //check save is come or not
    const checkSave = async () => {
        return new Promise(async (resolve, reject) => {
            while (true) {
                if (!JSON.parse(sessionStorage.getItem('sendDataAsPacket'))) {
                    return resolve()
                }

                await new Promise((reslove) => {
                    setTimeout(reslove, 100)
                })
            }
        })
    }

    //check the SAVE come from zing
    useEffect(() => {
        const messageHandler = (e) => {
            if (e.data.type === 'read' && e.data.value.includes('GRSV')) {
                sessionStorage.setItem('sendDataAsPacket', 'false')
            }
        }

        // Listen for messages from the extension
        // const extensionsMessageHandler = (event) => {
        //     // console.log("9999999999999999", event.data);
        //     if (event.data.type === 'response') {
        //         if (useRefExtensionsReadRef.current.commend === 'saveFile') {
        //             if (event.data.data === 'END') {
        //                 useRefExtensionsReadRef.current = {
        //                     commendSend: false,
        //                     commend: 'saveFile',
        //                     response: 'END',
        //                 }
        //             }
        //             console.log(
        //                 'Received message from extension:',
        //                 event.data.data
        //             )
        //         }
        //         // setReceivedMessage(event.data.data);
        //     }
        // }

        // window.addEventListener('message', extensionsMessageHandler)
        props.worker.addEventListener('message', messageHandler)

        return () => {
            props.worker.removeEventListener('message', messageHandler)
            // window.removeEventListener('message', extensionsMessageHandler)
        }
    }, [])

    const sendSaveDataAsPackets = async (data, size) => {
        const actionLength = JSON.parse(
            sessionStorage.getItem('createActionState')
        ).allActions.length
        let count = 0
        while (data.length !== 0) {
            if (status) {
                let dataToBeSentNow = data.splice(0, size)
                sendBytes(dataToBeSentNow, props.webSerial.port)
                count += 1
                status = false
                let replyOK
                try {
                    await Promise.race([
                        (replyOK = await readBytes(
                            props.webSerial.port,
                            count === actionLength ? 'SAVED' : 'OK'
                        )),
                        new Promise((_, reject) =>
                            setTimeout(reject, 2000, new Error('timeout'))
                        ),
                    ])
                    if (replyOK === false) {
                        status = true
                        break
                    }
                    if (count === actionLength && replyOK) {
                        sessionStorage.setItem('isSave', JSON.stringify(true))
                        setFeedback({
                            isOn: true,
                            msg: 'Action saved successfully',
                        })
                        setTimeout(() => {
                            setFeedback({
                                isOn: false,
                                msg: null,
                            })
                        }, 1000)
                    }
                    if (replyOK) {
                        status = true
                    }
                } catch (error) {
                    window.location.reload()
                }
            }
        }
    }

    return (
        <>
            {props.showPopUp && (
                <div className={style.container}>
                    {/* {true && <ActionLoader />} */}
                    <div
                        className={style.box}
                        style={{
                            width: '430px',
                            minHeight: '200px',
                            alignItems: 'center',
                        }}
                    >
                        <img
                            className={style.closeBtn}
                            style={{ width: '2.5rem' }} //top: '-60px'
                            src={renderImage('clos')}
                            onClick={() => {
                                if (showActionLoader) return
                                props.setFilePopUp(false)
                            }}
                        />

                        {actionsData?.allActions?.length > 0 ||
                        props.isNotCreateAction ? (
                            <>
                                {!props.isShowNewUI && (
                                    <input
                                        placeholder="Enter the name"
                                        style={{
                                            width: '15vw',
                                            height: '4.5vh',
                                            backgroundColor: 'lightgrey',
                                            textAlign: 'center',
                                            // position: 'absolute',
                                            borderRadius: '5px',
                                            border: 'none',
                                            // top: '46%',
                                            // left: '50%',
                                            // transform: 'translate(-50%,-50%)',
                                        }}
                                        type="text"
                                        value={fileName}
                                        autoFocus={true}
                                        onChange={inputHandler}
                                        disabled={showActionLoader}
                                    />
                                )}
                                <br></br>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-around',
                                        width: '100%',
                                    }}
                                >
                                    <button
                                        style={{
                                            background:
                                                ' linear-gradient(to right, #fda84e, #f97d62)',
                                            color: 'white',
                                            borderRadius: '7px',
                                        }}
                                        onClick={() => {
                                            if (showActionLoader) return
                                            saveFile()
                                        }}
                                    >
                                        {' '}
                                        Save to local
                                    </button>
                                    {
                                        <button
                                            style={{
                                                background:
                                                    ' linear-gradient(to right, #fda84e, #f97d62)',
                                                color: 'white',
                                                borderRadius: '7px',
                                            }}
                                            onClick={() => {
                                                if (showActionLoader) return
                                                uploadToBoard()
                                            }}
                                        >
                                            Save to{' '}
                                            {connectedDevice === 'Hexapod'
                                                ? 'crawl-e'
                                                : connectedDevice === 'Klaw'
                                                ? 'Klaw'
                                                : 'Zing'}
                                        </button>
                                    }
                                </div>
                            </>
                        ) : (
                            <>
                                <p>
                                    Please add at least one action before
                                    saving.
                                </p>
                            </>
                        )}
                    </div>

                    {showActionLoader && (
                        <div
                            style={{
                                position: 'absolute',
                            }}
                        >
                            <div className={loaderStyle.loader}>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    )}

                    {feedback.isOn ? (
                        <p
                            style={{
                                position: 'absolute',
                                bottom: '10%',
                            }}
                        >
                            {feedback.msg}
                        </p>
                    ) : (
                        <></>
                    )}
                </div>
            )}
        </>
    )
}
const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        deviceMismatch: (data) => {
            dispatch({ type: 'DEVICE_MISMATCH', payload: data })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SavePopUp)
